module.exports = __webpack_public_path__ + "img/default.7d75269a.png";